import { render, staticRenderFns } from "./MealItemCombo.vue?vue&type=template&id=08574bb4&scoped=true"
import script from "./MealItemCombo.vue?vue&type=script&lang=js"
export * from "./MealItemCombo.vue?vue&type=script&lang=js"
import style0 from "./MealItemCombo.vue?vue&type=style&index=0&id=08574bb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08574bb4",
  null
  
)

export default component.exports